// extracted by mini-css-extract-plugin
export default {"root":"IconHudl_root__pJG9d","fillColor":"IconHudl_fillColor__iJrU7"};